import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { VARIANT, SIZE } from './index'; // eslint-disable-line import/no-cycle

const fromTheme = (props, variant, prop) => props.theme.buttons[variant][prop];

export const ButtonText = styled.span`
  font-weight: 600;
  opacity: ${props => (props.loading ? 0.3 : 1)};
`;

export const Icon = styled.img`
  display: block;
  max-width: 16px;
`;

export const ButtonWrapper = styled.button`
  position: relative;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease-in-out;
  pointer-events: ${props => (props.loding ? 'none' : 'all')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  ${props => {
    switch (props.variant) {
      case VARIANT.PRIMARY:
        return css`
          background-color: ${fromTheme(props, 'primary', 'backgroundColor')};
          color: ${fromTheme(props, 'primary', 'textColor')};
          text-transform: uppercase;
        `;
      case VARIANT.SECONDARY:
        return css``;

      case VARIANT.TERTIARY:
        return css`
          background-color: #fff;
          ${ButtonText} {
            font-weight: 300;
          }
        `;

      case VARIANT.DANGER:
        return css``;
      default:
        return `background-color: transparent`;
    }
  }}
  ${props => {
    switch (props.size) {
      case SIZE.SMALL:
        return css`
          padding: 5px 10px;

          ${ButtonText} {
            font-size: 13px;
            line-height: 18px;
          }

          ${Icon} {
            margin-left: ${props.iconPos === 'suffix' ? '10px' : 0};
            margin-right: ${props.iconPos === 'prefix' ? '10px' : 0};
          }
        `;
      case SIZE.MEDIUM:
        return css`
          padding: 8px 12px;
          ${ButtonText} {
            font-size: 15px;
            line-height: 22px;
          }
          ${Icon} {
            margin-left: ${props.iconPos === 'suffix' ? '15px' : '3px'};
            margin-right: ${props.iconPos === 'prefix' ? '10px' : '3px'};
          }
        `;
      case SIZE.LARGE:
        return css`
          padding: 11px 16px;

          ${ButtonText} {
            font-size: 20px;
            line-height: 26px;
          }

          ${Icon} {
            margin-left: ${props.iconPos === 'suffix' ? '18px' : '4px'};
            margin-right: ${props.iconPos === 'prefix' ? '14px' : '2px'};
          }
        `;

      default:
        return css`
          background-color: transparent;
        `;
    }
  }};

  &:focus {
    outline: none;
  }
`;

export const Preloader = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;

  img {
    display: block;
    height: 50%;
  }
`;
